"use strict";
function pagination(){
    document.querySelectorAll(".load-more").forEach((btn) => {
      btn.classList.remove('loading');
      var url = btn.getAttribute('href');
      if (btn.classList.contains("infinite")){
        var observer = new IntersectionObserver(
          function(entries){
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1){
                loadMoreproducts(url);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(btn);
      } else {
        btn.addEventListener("click",(e) => {
            e.preventDefault();
            btn.classList.add('loading');
            loadMoreproducts(url);
          },
          false
        );
      }
    });
}
pagination();
function loadMoreproducts(url){
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'),
        products = document.getElementById('collection-products'),
        productsSource = html.querySelector('#collection-products').innerHTML,
        paginationEl = document.getElementById('pagination'),
        paginationSource = html.querySelector('#pagination');

      if(products) products.insertAdjacentHTML('beforeend', productsSource);
      if(paginationEl && paginationSource) {
        paginationEl.innerHTML = paginationSource.innerHTML;
      } else if (paginationEl) {
        paginationEl.innerHTML = '';
      }
    })
    .finally(() => {
      pagination();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
      initializeVideos();initBgimages();
      initializeScrollAnimationTrigger();
    })
    .catch((e) => {
      console.error(e);
    });
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var _this = this,
        fbtns = document.querySelectorAll(".btn-filter"),
        topFilters = document.querySelector(".filter-horizontal");

      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 767px)');
  
      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      this.selectSort();

      this.addEventListener('change', function(e){
        if (!e.target.classList.contains('optTag')) return;

        var URL = _this.dataset.url,
            paramString = new URLSearchParams(window.location.search),
            productFilters = document.querySelectorAll('input.optTag'),
            newTags = [],
            bytags = true;

        productFilters.forEach(function(el){
            if(el.value && el.checked){
                newTags.push(el.value);
            }
        });

        if (newTags.length) {
            var tags = newTags.join('+');
            _this.renderSectionFromFetch(URL + '/' + tags + '?' + paramString, bytags);
        } else {
            _this.renderSectionFromFetch(URL + '?' + paramString, bytags);
        }
      });

  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    if(!shortby) return;
    shortby.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input.dyfl, .price-range');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  priceRangeSlider(){
    const priceSlider = document.getElementById('priceSlider');
    if(!priceSlider) return;
    const min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE'),
      minDisplay = document.querySelector('[data-price-display="min"]'),
      maxDisplay = document.querySelector('[data-price-display="max"]');

    const formatPrice = (value) => {
      const cents = Math.round(value) * 100;
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }
      return Math.round(value).toLocaleString();
    };

    let submitTimer;
    priceSlider.addEventListener('change', (evt) => {
      const v1 = Math.round(evt.detail.value1);
      const v2 = Math.round(evt.detail.value2);
      min.value = v1.toString();
      max.value = v2.toString();
      if (minDisplay) minDisplay.textContent = formatPrice(v1);
      if (maxDisplay) maxDisplay.textContent = formatPrice(v2);

      clearTimeout(submitTimer);
      submitTimer = setTimeout(() => {
        min.dispatchEvent(new Event("change"));
      }, 250);
    });
  }
  onFormSubmit(e){
    const flForm = this.querySelector('form'),
      formData = new FormData(flForm),
      params = new URLSearchParams(formData);
      this.renderSectionFromFetch(params);
  }
  renderSectionFromFetch(params,tags){
    var url = `${window.location.pathname}?section_id=${this.secId}&${params.toString()}`
    if(tags){
        var url = `${params}&section_id=${this.secId}`
    }

    document.body.classList.add('load-filters');
    fetch(url).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html'),
          products = document.getElementById('collection-products'),
          filters = this.querySelector('.filters-item__wrapper'),
          counts = document.getElementById('itemsCount'),
          paginationEl = document.getElementById('pagination'),
          paginationSource =  html.querySelector('#pagination'),
          activeFilters =  document.getElementById('active-filters');

        if(counts && html.querySelector('#itemsCount')) counts.innerHTML = html.querySelector('#itemsCount').innerHTML;
        if(activeFilters && html.querySelector('#active-filters')) activeFilters.innerHTML = html.querySelector('#active-filters').innerHTML;
        if(products && html.querySelector('#collection-products')) products.innerHTML = html.querySelector('#collection-products').innerHTML;
        if(filters && html.querySelector('.filters-item__wrapper')) filters.innerHTML = html.querySelector('.filters-item__wrapper').innerHTML;
        if(paginationEl && paginationSource) {
          paginationEl.innerHTML = paginationSource.innerHTML;
        } else if(paginationEl) {
          paginationEl.innerHTML = ' ';
        }
      })
      .finally(() => {
        if(tags){
            var url = `${params.toString()}`
        } else {
            var url = `${window.location.pathname}?${params.toString()}`
        }
        history.pushState({ page: url }, url, url);
        document.body.classList.remove('load-filters');
        this.selectFilters();this.priceRangeSlider();this.removeFilters();pagination();
        if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
        initializeVideos();initBgimages();
        initializeScrollAnimationTrigger();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  removeFilters(){
    var _this = this,
        activeFl = document.querySelectorAll(".active-fl");
    activeFl.forEach((btn) => {
        btn.addEventListener("click",(e) => {
          e.preventDefault();
          var params = btn.getAttribute('href').split('?')[1];
          _this.renderSectionFromFetch(params);
        })
      });
  }
  mobileFilters(){
    var html = document.documentElement;
    html.classList.add('activ-filter','show-overly');
    const blocks = this.querySelectorAll('.filters-item');
    blocks.forEach((blk) => {
      blk.open = true;
    });
    document.querySelector(".closeFilter").addEventListener('click', function(e){
        html.classList.remove('activ-filter','show-overly');
    });
  }
  blockToggle(){
      const filterSelector = '.sidebar-widget.filters-item.pr.js-filter';

      this.addEventListener('toggle', (e) => {
        const activeFilter = e.target;
        if(!activeFilter.matches(filterSelector) || !activeFilter.open) return;

        this.querySelectorAll(`${filterSelector}[open]`).forEach((other) => {
          if(other !== activeFilter) other.removeAttribute('open');
        });
      }, true);

      document.body.addEventListener('click', (e) => {
        if(e.target.closest('.filters-item[open]')) return;

        this.querySelectorAll('.filters-item[open]').forEach((block) => {
          block.removeAttribute('open');
        });
      });
  }
}
customElements.define("filters-form", FiltersForm);

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});
